module.exports = __webpack_public_path__ + "img/tr.4db1e801.svg";